class AlternateShowtimes {
  #askProspectTimezone;
  #availableShowtimes;
  #wrapper;

  #proposedShowtimesDisplay() {
    return ['best', 'second', 'third']
      .map((optionKind) => {
        const dateSelect = this.#wrapper.querySelector(`.showtime_option.${optionKind} .date select`);
        const timeSelect = this.#wrapper.querySelector(`.showtime_option.${optionKind} .time select`);
        const dateOption = dateSelect.options[dateSelect.selectedIndex];
        const timeOption = timeSelect.options[timeSelect.selectedIndex];

        if (!dateOption || !timeOption) {
          return null;
        }

        return `${dateOption.text} @ ${timeOption.text.toLowerCase()}`;
      })
      .filter(Boolean)
      .join('<br/>');
  }

  updateProposedTimes() {
    const proposedTimes = document.querySelector('#showing_proposed_times');
    proposedTimes.value = this.#askProspectTimezone
      ? document.querySelector('.showtime_option.best .time select').value +
        ',' +
        document.querySelector('.showtime_option.second .time select').value +
        ',' +
        document.querySelector('.showtime_option.third .time select').value
      : document.querySelector('.showtime_option.best .date select').value +
        ' ' +
        document.querySelector('.showtime_option.best .time select').value +
        ',' +
        document.querySelector('.showtime_option.second .date select').value +
        ' ' +
        document.querySelector('.showtime_option.second .time select').value +
        ',' +
        document.querySelector('.showtime_option.third .date select').value +
        ' ' +
        document.querySelector('.showtime_option.third .time select').value;
    proposedTimes.dispatchEvent(new Event('change', { bubbles: true }));
    this.#wrapper.dispatchEvent(
      new CustomEvent('alternate-showtimes:selection-changed', {
        detail: { displayValue: this.#proposedShowtimesDisplay() },
      }),
    );
  }

  updateShowtimeTimes1() {
    const prev_time = document.querySelector('#showing_proposed_time_best').value;
    document.querySelector('#showing_proposed_time_best').innerHTML = '';
    const current_date = document.querySelector('#showing_proposed_date_best').value;
    let opt;
    this.#availableShowtimes.forEach((time_array) => {
      if (this.#askProspectTimezone) {
        const value = time_array[0] + ' ' + time_array[1];
        if (current_date == time_array[2]) {
          opt = `<option value="${value}" ${prev_time == value ? 'selected' : ''}>${time_array[3]}</option>`;
          document.querySelector('#showing_proposed_time_best').insertAdjacentHTML('beforeend', opt);
        }
      } else {
        if (current_date == time_array[0]) {
          opt = `<option value="${time_array[1]}" ${prev_time == time_array[1] ? 'selected' : ''}>${time_array[1]}</option>`;
          document.querySelector('#showing_proposed_time_best').insertAdjacentHTML('beforeend', opt);
        }
      }
    });

    document.dispatchEvent(new CustomEvent('alternate-showtimes:updated'));
  }

  updateShowtimeTimes2() {
    const prev_time = document.querySelector('#showing_proposed_time_second').value;
    document.querySelector('#showing_proposed_time_second').innerHTML = '';
    const current_date = document.querySelector('#showing_proposed_date_second').value;
    let opt;
    this.#availableShowtimes.forEach((time_array) => {
      if (this.#askProspectTimezone) {
        const value = time_array[0] + ' ' + time_array[1];
        if (current_date == time_array[2]) {
          opt = `<option value="${value}" ${prev_time == value ? 'selected' : ''}>${time_array[3]}</option>`;
          document.querySelector('#showing_proposed_time_second').insertAdjacentHTML('beforeend', opt);
        }
      } else {
        if (current_date == time_array[0]) {
          opt = `<option value="${time_array[1]}" ${prev_time == time_array[1] ? 'selected' : ''}>${time_array[1]}</option>`;
          document.querySelector('#showing_proposed_time_second').insertAdjacentHTML('beforeend', opt);
        }
      }
    });

    document.dispatchEvent(new CustomEvent('alternate-showtimes:updated'));
  }

  updateShowtimeTimes3() {
    const proposedTimeThird = document.querySelector('#showing_proposed_time_third');
    if (proposedTimeThird) {
      const prev_time = proposedTimeThird.value;
      proposedTimeThird.innerHTML = '';
      const current_date = document.querySelector('#showing_proposed_date_third').value;
      let opt;
      this.#availableShowtimes.forEach((time_array) => {
        if (this.#askProspectTimezone) {
          const value = time_array[0] + ' ' + time_array[1];
          if (current_date == time_array[2]) {
            opt = `<option value="${value}" ${prev_time == value ? 'selected' : ''}>${time_array[3]}</option>`;
            proposedTimeThird.insertAdjacentHTML('beforeend', opt);
          }
        } else {
          if (current_date == time_array[0]) {
            opt = `<option value="${time_array[1]}" ${prev_time == time_array[1] ? 'selected' : ''}>${time_array[1]}</option>`;
            proposedTimeThird.insertAdjacentHTML('beforeend', opt);
          }
        }
      });

      document.dispatchEvent(new CustomEvent('alternate-showtimes:updated'));
    }
  }

  bindEvents() {}

  init(wrapper) {
    this.#wrapper = wrapper;
    this.#askProspectTimezone = JSON.parse(wrapper.dataset.askProspectTimezone);
    const availableDates = JSON.parse(wrapper.dataset.availableDates);
    this.#availableShowtimes = JSON.parse(wrapper.dataset.availableShowtimes);
    const persistedShowtimes = JSON.parse(wrapper.dataset.persistedShowtimes);

    availableDates.forEach((date_array) => {
      const opt = `<option value=${date_array[1]}>${date_array[0]}</option>`;
      document.querySelector('#showing_proposed_date_best').insertAdjacentHTML('beforeend', opt);
      document.querySelector('#showing_proposed_date_second').insertAdjacentHTML('beforeend', opt);
      document.querySelector('#showing_proposed_date_third').insertAdjacentHTML('beforeend', opt);
    });

    const proposedTimesArr = document.querySelector('#showing_proposed_times').value.split(',').slice(0, 3);
    const restorableShowtimes = [...this.#availableShowtimes, ...persistedShowtimes];
    const initialShowtimePairs = proposedTimesArr.map((proposedTime) => {
      return restorableShowtimes.find((timeArray) => {
        return `${timeArray[0]} ${timeArray[1]}` === proposedTime.trim();
      });
    });
    const initialShowtimesCanBeRestored =
      initialShowtimePairs.length === 3 && initialShowtimePairs.every((timeArray) => timeArray);

    let initialDates = [];
    let initialTimes = [];
    let initialTimeLabels = [];
    if (initialShowtimesCanBeRestored) {
      if (this.#askProspectTimezone) {
        initialDates = initialShowtimePairs.map((timeArray) => timeArray[2]);
        initialTimes = initialShowtimePairs.map((timeArray) => `${timeArray[0]} ${timeArray[1]}`);
        initialTimeLabels = initialShowtimePairs.map((timeArray) => timeArray[3]);
      } else {
        initialDates = initialShowtimePairs.map((timeArray) => timeArray[0]);
        initialTimes = initialShowtimePairs.map((timeArray) => timeArray[1]);
        initialTimeLabels = initialTimes;
      }
    }

    if (initialShowtimesCanBeRestored) {
      document.querySelector('#showing_proposed_date_best').value = initialDates[0];
      document.querySelector('#showing_proposed_date_second').value = initialDates[1];
      document.querySelector('#showing_proposed_date_third').value = initialDates[2];
    } else {
      if (availableDates.length > 0) {
        document.querySelector('#showing_proposed_date_best').value = availableDates[0][1];
        if (availableDates.length > 1) {
          document.querySelector('#showing_proposed_date_second').value = availableDates[1][1];
          if (availableDates.length > 2) {
            document.querySelector('#showing_proposed_date_third').value = availableDates[2][1];
          }
        }
      }
    }
    this.updateShowtimeTimes1();
    this.updateShowtimeTimes2();
    this.updateShowtimeTimes3();

    ['best', 'second', 'third'].forEach((optionKind, index) => {
      if (!initialTimes[index]) {
        return;
      }

      const timeSelect = document.querySelector(`#showing_proposed_time_${optionKind}`);
      const optionExists = Array.from(timeSelect.options).some((option) => option.value === initialTimes[index]);
      if (!optionExists) {
        timeSelect.add(new Option(initialTimeLabels[index], initialTimes[index]));
      }
      timeSelect.value = initialTimes[index];
    });

    this.updateProposedTimes();
    document
      .querySelector('#showing_proposed_date_best')
      .addEventListener('change', this.updateShowtimeTimes1.bind(this));
    document
      .querySelector('#showing_proposed_date_second')
      .addEventListener('change', this.updateShowtimeTimes2.bind(this));
    document
      .querySelector('#showing_proposed_date_third')
      .addEventListener('change', this.updateShowtimeTimes3.bind(this));
    wrapper.querySelectorAll('.showtime_option .date select, .showtime_option .time select').forEach((select) => {
      select.addEventListener('change', this.updateProposedTimes.bind(this));
    });

    this.bindEvents();

    document.dispatchEvent(new CustomEvent('alternate-showtimes:updated'));
  }
}

export default AlternateShowtimes;
